@if (product().gallery.length) {
  <article class="main-carousel__container">
    <div
      class="splide main-carousel is-active is-overflow is-initialized"
      role="region"
      [id]="'main-carousel_' + product().id"
      aria-label="Main carousel"
    >
      @if (showLowestPriceTag()) {
        <span class="product-page__lowest-price lowest-price">
          <i class="fal fa-tag"></i>
          <span i18n="@@product.lowestPrice">Lowest price in 30 days</span>
        </span>
      }
      <div class="splide__track">
        <div class="splide__list">
          <!-- TODO: This library is loading all images at the start, we should fix this to defer download the ones that are not visible at start -->
          @for (item of product().gallery; track item) {
            @let isActive = $index === 0;
            <div class="splide__slide" [ngStyle]="{ 'max-height': mainImageHeight + 'px' }">
              <div class="main-carousel__item">
                <!-- FIXME: ngSrcset should have 918 and 1258 for 2.0 DPR but we need webp for png images or they are huge-->
                <img
                  ngSrcset="459w, 629w"
                  sizes="(max-width: 767.9px) 100vw, (max-width: 1199px) 50vw, 25vw"
                  class="main-carousel__image"
                  width="629"
                  height="629"
                  [priority]="isActive"
                  [ngSrc]="item.url"
                  [alt]="defaultAltText()"
                  [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
                  (error)="item.url = missingProductImageUrl"
                />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div
      class="splide main-carousel__thumbnails"
      role="region"
      [id]="'main-carousel__thumbnails-' + product().id"
      aria-label="Thumbnails carousel"
    >
      <div class="splide__track">
        <div #thumbnailsPresentation class="splide__list">
          @for (item of product().gallery; track item) {
            <div class="splide__slide main-carousel__slide">
              <div class="main-carousel__thumbnails-item">
                <img
                  ngSrcset="102w, 204w"
                  class="main-carousel__thumbnails-image"
                  width="102"
                  height="102"
                  [ngSrc]="item.url"
                  [alt]="defaultAltText()"
                  [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
                  (error)="item.url = missingProductImageUrl"
                />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </article>
}
